import axios from "axios";
import { getAuthorizationToken } from "../config/user";
const REACT_APP_API_URL = process.env.REACT_APP_API_URL;

function getICDToken(data) {
  return axios({
    method: "get",
    url: `${REACT_APP_API_URL}/get-icd-data`,

    headers: getAuthorizationToken(),
  });
}

export const ICDservices = {
  getICDToken,
};
